const DEFAULT_MAX_SHOWN = 2

/** Formats up to `maxShown` glosses, then "+N" for any remaining count. */
export function formatTranslationPreview(
  translations: string[],
  maxShown = DEFAULT_MAX_SHOWN,
  totalCount?: number,
): string {
  if (translations.length === 0) {
    return ''
  }
  const total = totalCount ?? translations.length
  if (total <= 1) {
    return translations[0]
  }
  const shown = translations.slice(0, maxShown)
  const extra = total - shown.length
  if (extra > 0) {
    return `${shown.join(', ')} +${extra}`
  }
  return shown.join(', ')
}

export function translationPreviewExtraCount(
  translations: string[],
  maxShown = DEFAULT_MAX_SHOWN,
  totalCount?: number,
): number {
  const total = totalCount ?? translations.length
  return Math.max(0, total - Math.min(maxShown, translations.length, total))
}
